import { Box, Tabs, Tab, Typography, Button, styled } from '@mui/material'

export const VerticalTabsContainer = styled(Box, {
  shouldForwardProp: prop => prop !== 'isSmallScreen',
})<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
  position: 'relative',
  border: `1px solid ${theme.palette.paleBlue.light}`,
  borderRadius: '1px',
  backgroundColor: 'white',
  color: 'black',
  height: isSmallScreen ? '70vh' : 'auto',
  width: isSmallScreen ? '136px' : '274px',
  margin: '12px 0px 12px 10px',
  display: 'flex',
  flexDirection: 'column',
}))

export const StyledTabs = styled(Tabs, {
  shouldForwardProp: prop => prop !== 'isSmallScreen',
})<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
  flex: 1,
  minHeight: 0,
  maxHeight: window.innerHeight - 280,
  marginBottom: isSmallScreen ? 2 : 0,
  overflowY: isSmallScreen ? 'auto' : 'visible',
  '& .MuiTab-root': {
    textAlign: 'left',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: isSmallScreen ? '90px' : '248px',
    height: isSmallScreen ? '60px' : '44px',
    minWidth: isSmallScreen ? '80px' : '150px',
  },
  '& .Mui-selected': {
    backgroundColor: theme.palette.primary.main,
  },
}))

export const StyledTab = styled(Tab, {
  shouldForwardProp: prop => prop !== 'isSmallScreen',
})<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
  marginLeft: '12px',
  marginBottom: '4px',
  width: isSmallScreen ? '100px' : '248px',
  height: isSmallScreen ? '60px' : '44px',
  border: `1px solid ${theme.palette.paleBlue.light}`,
  borderRadius: '4px',
  minWidth: isSmallScreen ? '100px' : '150px',
}))

export const IconCountRow = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
})

export const CountBox = styled(Box)(({ theme }) => ({
  width: 28,
  height: 20,
  borderRadius: '2px',
  border: `1px solid ${theme.palette.paleBlue.light}`,
  backgroundColor: theme.palette.background.paper,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 4,
}))

export const TabTextBox = styled(Box)({
  marginTop: 4,
  width: '100%',
})

export const TabTextTypography = styled(Typography)(({ theme }) => ({
  textTransform: 'none',
  fontSize: '0.95rem',
  width: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const AddEquipmentButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'isSmallScreen',
})<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
  marginLeft: '12px',
  marginRight: '12px',
  marginBottom: '4px',
  width: isSmallScreen ? '90px' : '248px',
  height: isSmallScreen ? '60px' : '44px',
  boxShadow: 'none',
  color: theme.palette.primary.main,
  textTransform: 'none',
  border: `1px dashed ${theme.palette.primary.main}`,
  borderRadius: '4px',
  backgroundColor: '#F1F5F7',
  justifyContent: 'flex-start',
  paddingLeft: '12px',
  gap: theme.spacing(1),
  '&:hover': {
    backgroundColor: '#E6EDF0',
    boxShadow: 'none',
  },
}))

export const TabTitle = styled(Box, {
  shouldForwardProp: prop => prop !== 'isSmallScreen',
})<{ isSmallScreen: boolean }>(({ theme, isSmallScreen }) => ({
  position: 'absolute',
  top: isSmallScreen ? '5px' : '27px',
  left: '18px',
  zIndex: 2,
  backgroundColor: 'white',
  width: isSmallScreen ? '100%' : '20%',
  '& .MuiTypography-root': {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
}))
